import { useQuery } from "react-query";

import type { ContactPersonal } from "@jti/fe-common/types";

import { CasProfileApi } from "../../../services";
import { getUser } from "../../../utils/User";

export const useUserProfile = (): ContactPersonal | null => {
  const { uuid, ciam_token } = getUser();
  const isUserLoggedIn = Boolean(uuid && ciam_token);
  const { data } = useQuery("profile", () => CasProfileApi.init().getProfile(), { enabled: isUserLoggedIn });

  return data?.personalInfo || null;
};
